import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TracksPage from './pages/TracksPage';
import TrackTasksPage from './pages/TrackTasksPage';

function App() {
  return (
    <Routes>
      {/* Redirect root to /tracks */}
      <Route path="/" element={<Navigate to="/tracks" replace />} />
      
      {/* Tracks listing page */}
      <Route path="/tracks" element={<TracksPage />} />
      
      {/* Individual track tasks page */}
      <Route path="/track/:trackSlug/tasks" element={<TrackTasksPage />} />
      
      {/* Catch-all redirect to tracks */}
      <Route path="*" element={<Navigate to="/tracks" replace />} />
    </Routes>
  );
}

export default App;
